import React from 'react';
import { Hue, Saturation } from 'react-color/lib/components/common';
import ColorWrap from 'react-color/lib/components/common/ColorWrap';

import { Pointer } from './Pointer';
import { PointerCircle } from './PointerCircle';

import styles from './CustomPicker.scss';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const picker = ({ hsl, hsv, onChange }: any) => (
  <>
    <div className={styles.saturation} data-test="color-picker">
      <Saturation {...{ hsl, hsv, pointer: PointerCircle, onChange }} />
    </div>
    <br />
    <div className={styles.hue} data-test="color-slide">
      <Hue {...{ hsl, direction: 'horizontal', pointer: Pointer, onChange }} />
    </div>
  </>
);

export const CustomPicker = ColorWrap(picker);
